import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorPolicyService, muteError } from '@mri-platform/angular-error-handling';
import { ErrorEvent, FileRestrictions } from '@progress/kendo-angular-upload';

/**
 * Service that the `AvatarIconSelectorFormComponent` will use for its configuration
 *
 * @example
 *   providers: [AvatarImageUploadService]
 * })
 * export class YourPageComponent {
 *   constructor(uploadService: AvatarImageUploadService, api: ApiConfig, auth: AuthService) {
 *     uploadService.uploadUrl = `${api.url}/uploadimage`;
 *     const authzHeader = `Bearer ${auth.getAccessToken()}`;
 *     uploadService.uploadHeaders = new HttpHeaders().set('Authorization', authzHeader);
 *   }
 * }
 */
@Injectable()
export class AvatarImageUploadService {
  /**
   * File upload size and file type (extension) restrictions to enforce client-side
   *
   * *IMPORTANT* these restrictions, particularly file size, need to also be enforced
   * on the server-side to guard against DoS attacks and the like
   *
   */
  uploadFileRestrictions: FileRestrictions = {
    maxFileSize: 102400,
    allowedExtensions: ['.jpg', '.jpeg', '.png', '.svg']
  };

  /**
   * Headers to add to the http request to upload an image.
   * @example
   * uploadService.uploadHeader = new HttpHeaders().set('Authorization', `Bearer ${this.authService.getAccessToken()}`)
   */
  uploadHeaders?: HttpHeaders;

  /**
   * The url to upload images too
   */
  uploadUrl = '';

  constructor(private readonly errorPolicy: ErrorPolicyService) {}

  /**
   * The function that will used to handle any error that occurs when uploading image
   * The default implementation will log the http server error response (silently)
   * @param err the upload error event containing
   */
  handleUploadFailure = (err: ErrorEvent) => {
    this.errorPolicy.log(err.response, muteError);
  };
}
